import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import NotificationTemplateType from '@/plugins/sdk/resources/NotificationTemplateType'
import Account from '@/plugins/sdk/resources/Account'
import Team from '@/plugins/sdk/resources/Team'

export default class extends Resource {
  static name = 'notificationtemplate'

  static get fields () {
    return {
      id: new UUID(),
      email_reply_to: new STRING(),
      email_subject: new STRING(),
      email_header_colour: new STRING(),
      email_header_text: new STRING(),
      email_header_url: new STRING(),
      email_greeting: new STRING(),
      email_line_one: new STRING(),
      email_action: new STRING(),
      email_line_two: new STRING(),
      email_salutation: new STRING(),
      email_footer_text: new STRING(),
      sms_sender_name: new STRING(),
      sms_message: new STRING(),
      webhook_url: new STRING(),
      webhook_contents: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      type: new ITEM(NotificationTemplateType),
      account: new ITEM(Account),
      team: new ITEM(Team)
    }
  }
}
